import { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import { useSelector } from "react-redux";
import "./ApprenticePathsIndex.scss";
import { useTranslation } from "react-i18next";
import Loading from "components/Loading";
import { Row, Col, Form } from "react-bootstrap";
import ApprenticePathCard from "components/ApprenticePathCard/ApprenticePathCard";
import { useComponentWillMount } from "hooks/useComponentWillMount";

const ApprenticePathsIndex = ({ currentLanguageId }) => {
  const { t } = useTranslation();
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { data, get, isLoading } = useFetch();
  const [input, setInput] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [selectedPathId, setSelectedPathId] = useState(null);

  const updateDeviceSize = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", updateDeviceSize);
    updateDeviceSize();
  }, []);

  useComponentWillMount(() =>
    window.removeEventListener("resize", updateDeviceSize)
  );

  useEffect(() => {
    if (currentUser) {
      get(
        `/learning_paths?apprentice_paths=true&current_user=${currentUser.id}&language=${currentLanguageId}`
      );
    }
  }, [currentUser, currentLanguageId]);

  return (
    <div className="ApprenticePathsIndex">
      <Row style={{ minHeight: "90vh" }}>
        <Col className="col-lg-3 sidemenu d-flex flex-column align-items-center">
          <h5 className="my-3">{t("common:your_learning_paths")}</h5>
          <div className="w-100">
            <div className="d-flex flex-column align-items-center mt-4">
              <div className="mb-2">
                <Form>
                  <Form.Check
                    custom
                    type="radio"
                    id="all"
                    name="learning_path"
                    checked={selectedPathId === null}
                    onChange={() => setSelectedPathId(null)}
                    className="custom-radio mb-2"
                    label={t("common:show_all")}
                  />

                  {data &&
                    data.map((lp) => (
                      <div key={lp.id} className="mb-2">
                        <Form.Check
                          custom
                          type="radio"
                          id={`lp-${lp.id}`}
                          name="learning_path"
                          checked={selectedPathId === lp.id}
                          onChange={() => setSelectedPathId(lp.id)}
                          className="custom-radio"
                          label={lp.title}
                        />
                      </div>
                    ))}

                </Form>
              </div>
            </div>
          </div>
        </Col>

        {(isLoading && <Loading isMobile={isMobile} />) || (
          <Col className="col-lg-8 mx-auto">
            <Row className="mx-3 p-0">
              {(data &&
                data
                  .filter((value) =>
                    selectedPathId === null || value.id === selectedPathId
                  )
                  .map((path) => (
                    <ApprenticePathCard
                      key={path.id}
                      learningPath={path}
                      imgHeight="200px"
                    />
                  ))) ||
                (!isLoading && <h3 className="text-center mt-3">{t("common:no_paths_found")}</h3>)}
            </Row>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ApprenticePathsIndex;
